import { render, staticRenderFns } from "./TaskAddedAttachment.vue?vue&type=template&id=b8243f86&scoped=true"
import script from "./TaskAddedAttachment.vue?vue&type=script&lang=js"
export * from "./TaskAddedAttachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8243f86",
  null
  
)

export default component.exports